var map = {
	"./cards/DeFi.avif": 34106,
	"./cards/GameFi.avif": 76126,
	"./cards/Web3CommerceImage.avif": 86776,
	"./cards/Web3FundManagementImage.avif": 23227,
	"./defi/DeFiBanner.avif": 65947,
	"./defi/DeFiBanneriPhone.avif": 44078,
	"./gamefi/GameFiBanner.avif": 38095,
	"./gamefi/GameFiBanneriPhone.avif": 80890,
	"./web3-fund-management/banner.avif": 95134,
	"./web3-fund-management/banneriPhone.avif": 61289,
	"./web3-fund-management/blog-fake-cover.avif": 21849,
	"./web3-fund-management/payment-fake-cover.avif": 33633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10002;